import ActionDispatcherService from '../common/actions/core/action-dispatcher.service';
import { OpenLoginDialogAction } from '../components/login-dialog/login-dialog.action';

/* @ngInject */
export default class LoginController {
  constructor(
    private $stateParams,
    private actionDispatcher: ActionDispatcherService,
    private config
  ) { }

  public $postLink() {
    // ToDo: this code dispatch login dialog
    if (this.config.auth.useLegacyLogin) {
      this.actionDispatcher.dispatch(
        new OpenLoginDialogAction(this.$stateParams.transition)
      );
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.controller.ts